import PaymentSettingsForm from '../organisms/forms/PaymentSettingsForm';
import { PAYMENT_TYPE } from '../../constants/enums';
import { usePaymentSettings } from '../../hooks/usePaymentSettings';

const DepositSettingsPage = () => {
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    onFormSubmit,
    hideInputs,
    approvalModeOptions,
  } = usePaymentSettings(PAYMENT_TYPE.DEPOSIT);

  return (
    <PaymentSettingsForm
      isDirty={isDirty}
      control={control}
      errors={errors}
      onSave={handleSubmit(onFormSubmit)}
      hideInputs={hideInputs}
      approvalModeOptions={approvalModeOptions}
    />
  );
};

export default DepositSettingsPage;
